import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { createTask, getTeamSettings } from "@/lib/api";
import { emptyTaskForm, TaskFormFields, buildTaskPayload } from "@/lib/taskFormShared";
import { toast } from "sonner";

export default function NewTaskDialog({ open, onOpenChange, onCreated, initialOrderId = "" }) {
  const [form, setForm] = useState(() => ({ ...emptyTaskForm(), order_id: initialOrderId || "" }));
  const [assignees, setAssignees] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setForm({ ...emptyTaskForm(), order_id: initialOrderId || "" });
      getTeamSettings()
        .then((r) => setAssignees(r.data?.task_assignees || []))
        .catch(() => {});
    }
  }, [open, initialOrderId]);

  const handleCreate = async () => {
    const { payload, error } = buildTaskPayload(form, assignees);
    if (error) {
      toast.error(error);
      return;
    }
    setSaving(true);
    try {
      await createTask(payload);
      toast.success("Task added");
      onOpenChange(false);
      onCreated?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to add task");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg border-2 border-[#4A4A4A]" data-testid="new-task-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-[#2D2D2D]">New task</DialogTitle>
        </DialogHeader>
        <TaskFormFields f={form} setF={setForm} assignees={assignees} idPrefix="global-new-task" />
        <div className="flex gap-2 justify-end mt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button className="btn-primary" onClick={handleCreate} disabled={saving} data-testid="global-new-task-save">
            {saving ? "Saving…" : "Save"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
